import React from "react";

export function forms() {
  return (
    <div>
      <iframe
        width="100%"
        height="1000vh"
        src="https://forms.office.com/Pages/ResponsePage.aspx?id=OGRa6DOLKUq4fpqu_-y7-Vi_8I2VQOhKhtwq414QewRURFkyRkYyTFk4NERURlQ0VTBRQkREOUVUTS4u&embed=true"
        frameBorder="0"
        marginWidth={0}
        marginHeight={0}
        allowFullScreen
      >
        {" "}
      </iframe>
    </div>
  );
}
